import React, { useState } from 'react';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import {
    Avatar,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Checkbox,
    Divider,
    Button,
    Link,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Typography
} from '@material-ui/core';

import TableEditBar from '../../../../components/TableEditBar/TableEditBar';
import { AssignmentIndRounded } from '@material-ui/icons';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import EmailIcon from '@material-ui/icons/Email';
import ContactPhoneIcon from '@material-ui/icons/ContactPhone';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import EditAdmin from '../../../EditAdmin/EditAdmin';
import DeleteIcon from '@material-ui/icons/Delete';
import { delete_admin } from '../../../../api/API';
 
const useStyles = makeStyles(theme => ({
    root: {},

    content: {
        padding: 0
    },

    inner: {
        minWidth: 700,
    },

    nameCell: {
        display: 'flex',
        alignItems: 'center'
    },

    avatar: {
        height: 42,
        width: 42,
        marginRight: theme.spacing(1)
    },

    actions: {
        padding: theme.spacing(1),
        justifyContent: 'flex-end'
    },

    scroll: {
        overflow: "auto",
    }


}));

export default function TableList(props) {

    const history = useHistory();
    const { className, admins, ...rest } = props;

    const classes = useStyles();

    const [selectedAdmin, setSelectedAdmin] = useState(null);
    const handleEditClose = () => {
        setShowEdit(false);
        props.refresh();
    };
    const [showEdit, setShowEdit] = useState(false);

    const handleDelete = async (admin_id) => {
        if (window.confirm("Are you sure ?")) {
            let data = await delete_admin(admin_id);
            if (data) {
                props.refresh();
            } else {
                alert("Something went wrong");
            }

        }
    }
    const toPage = (admin_id) => { history.push('/admin/detailadmin/' + admin_id); };

    return (
        <div
            {...rest}
            className={clsx(classes.root, className)}
        >
            <Typography
                color="textSecondary"
                gutterBottom
                variant="body2"
            >
                {/* {admins.length} Records found. Page {page + 1} of{' '}
            {Math.ceil(admins.length / rowsPerPage)} */}
            </Typography>
            <Card>
                <CardHeader
                    //   action={<GenericMoreButton />}
                    title="Users"
                />
                <Divider />
                <CardContent className={classes.content}>
                        <div className={classes.inner + " " + classes.scroll + " data_list_container"}>

                            {admins.map(admin => (  
                                <div className="data_list_view">
                                    <div className="info">
                                        <h3>{admin.name}</h3>
                                        <p><EmailIcon></EmailIcon>
                                            {admin.email}</p>
                                        <p><ContactPhoneIcon></ContactPhoneIcon>
                                            {admin.contact}</p>
                                        <p><AssignmentIndIcon></AssignmentIndIcon>
                                            {admin.role}</p>
                                    </div>
                                    <div className="actions">
                                        <div className="button_wrapper">
                                            {/* <Button
                                                className="list_button"
                                                onClick={() => toPage(admin.admin_id)}
                                                variant="outlined"
                                            ><VisibilityIcon
                                            ></VisibilityIcon></Button> */}
                                            <Button
                                                onClick={() => {
                                                    setSelectedAdmin(admin);
                                                    setShowEdit(true);
                                                }}
                                                className="list_button"
                                                variant="outlined"
                                            ><EditIcon></EditIcon>

                                            </Button>
                                            <Button
                                                onClick={() => {
                                                    handleDelete(admin.admin_id)
                                                }}
                                                className="list_button"
                                                variant="outlined"
                                            ><DeleteIcon

                                            ></DeleteIcon>
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                </CardContent>

            </Card>

            {
                showEdit && (
                    <EditAdmin
                        admins={selectedAdmin}
                        onClose={handleEditClose}
                        open={showEdit}
                    />)
            }
        </div>
    );


}